import React, { memo, useState } from "react";
import { Control, UseFormSetValue, useWatch } from "react-hook-form";
import Button from "../../../components/ui/Button/Button";
import { OfferSaleType } from "../../../common/dataTypes/OfferSaleType";
import ReceiptPhotoField from "./ReceiptPhotoField";
import styles from "../OfferSale.module.scss";

import langs from "../../../common/services/languageService";
const { labels } = langs;

interface SaleConfirmProps {
  onSubmit: () => void;
  control: Control<OfferSaleType, any>;
  setValue: UseFormSetValue<OfferSaleType>;
}

const SaleConfirm: React.FC<SaleConfirmProps> = ({ onSubmit, setValue, control }) => {
  const [comment, setComment] = useState("");
  const receiptPhoto = useWatch({ control, name: "receiptPhoto" });
  const isSubmitDisabled = !receiptPhoto;

  return (
    <>
      <div style={{ alignItems: "center" }}>
        <span>{labels.CustomerAlreadyRegistered()}</span>
      </div>
      <div className={styles.saleConfirmationForm}>
        <ReceiptPhotoField control={control} />
        <div className={styles.commentField}>
          <label htmlFor="sale-comment">{labels.OptionalCommentHint()}</label>
          <textarea
            id="sale-comment"
            value={comment}
            rows={5}
            onChange={(e) => {
              setComment(e.target.value);
              setValue("comment", e.target.value);
            }}
          />
        </div>
      </div>
      <Button className={styles.submitButtonSpacing} disabled={isSubmitDisabled} onClick={onSubmit}>{labels.Confirm().toLowerCase()}</Button>
    </>
  );
};

export default memo(SaleConfirm);
